<template>
    <v-tab v-bind="$attrs" class="pl-0 pr-8px min-w-auto">
        <v-btn large outlined color="secondary" class="min-w-md-120px" @click="$emit('click')">
            <span class="font-size-md-18"><slot /></span>
        </v-btn>
    </v-tab>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
